const EXTENSION_FOR: Record<string, string> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/webp': 'webp',
  'image/gif': 'gif',
};

/**
 * The files on a paste event, in clipboard order, ready for the same upload
 * path as the attach button.
 *
 * A pasted screenshot or copied image does not always arrive as a tidy File:
 * some sources give it no name, and some give the File an empty `type` while
 * the clipboard item still says what it is. The upload is signed for the
 * declared type and validated against it, so an empty type was refused (or
 * signed for the wrong one) and the chip failed. Take the type from the item
 * when the file has none, and give a nameless image a name.
 */
export function filesFromClipboard(
  items: DataTransferItemList | ArrayLike<DataTransferItem> | null | undefined
): File[] {
  const files: File[] = [];
  for (const item of Array.from(items ?? [])) {
    if (item.kind !== 'file') continue;
    const file = item.getAsFile();
    if (!file) continue;
    const type = file.type || item.type || '';
    const name =
      file.name ||
      `pasted-image-${files.length + 1}.${EXTENSION_FOR[type] ?? 'png'}`;
    files.push(
      type === file.type && name === file.name
        ? file
        : new File([file], name, { type, lastModified: file.lastModified })
    );
  }
  return files;
}
